import { DrawerItem } from '@/interfaces/drawer'
export function routerList () {
  const list: DrawerItem[] = [
    {
      title: 'Dashboard',
      routeTo: 'Dashboard',
      display: true,
      index: 0,
      width: 96,
      subList: [
        {
          title: 'Dashboard',
          icon: require('@/assets/v2/icon_menu_dashboard.png'),
          iconW: 20,
          iconH: 19,
          routeTo: 'Dashboard',
          index: 1,
          height: 90
        },
        {
          title: 'Calendar',
          icon: require('@/assets/v2/icon_menu_calendar.png'),
          iconW: 20,
          iconH: 19,
          routeTo: 'Calendar',
          index: 1,
          height: 90
        }
      ]
    },
    {
      title: 'Insurance Cases',
      display: true,
      index: 1,
      width: 124,
      subList: [
        {
          title: 'Cases',
          icon: require('@/assets/v2/icon_menu_case.png'),
          iconW: 20,
          iconH: 20,
          routeTo: 'CaseDashboard',
          index: 0,
          height: 90
        },
        {
          title: 'Quotes',
          icon: require('@/assets/v2/icon_menu_quote.png'),
          iconW: 20,
          iconH: 17.5,
          routeTo: 'QuotesList',
          index: 2,
          height: 90
        },
        {
          title: 'Policies',
          icon: require('@/assets/v2/icon_menu_policy.png'),
          iconW: 21,
          iconH: 20,
          routeTo: 'PoliciesList',
          index: 3,
          height: 90
        },
        {
          title: 'Cases.2.0',
          icon: require('@/assets/v2/icon_menu_case.png'),
          iconW: 20,
          iconH: 20,
          routeTo: 'NewcaseDashboard',
          index: 1,
          height: 90
        },
        {
          title: 'File Upload',
          icon: require('@/assets/v2/icon_file_upload.png'),
          iconW: 20,
          iconH: 20,
          routeTo: 'OcrFileUpload',
          index: 4,
          height: 90
        }
      ]
    },
    {
      title: 'Client Information',
      display: true,
      index: 2,
      width: 136,
      subList: [
        {
          title: 'Client With Open Case',
          icon: require('@/assets/v2/icon_menu_client_with_case.png'),
          iconW: 22,
          iconH: 20,
          routeTo: 'AccountsWithCases',
          index: 0,
          height: 110
        },
        {
          title: 'Accounts',
          icon: require('@/assets/v2/icon_menu_client.png'),
          iconW: 21,
          iconH: 16,
          routeTo: 'AccountsList',
          index: 1,
          height: 90
        },
        {
          title: 'Contacts',
          icon: require('@/assets/v2/icon_menu_contact.png'),
          iconW: 21,
          iconH: 20,
          routeTo: 'ContactList',
          index: 2,
          height: 90
        }
      ]
    },
    {
      title: 'Accountings',
      display: true,
      index: 3,
      width: 106,
      routeTo: 'StatementUploadList',
      subList: [
        {
          title: 'Statement Upload',
          icon: require('@/assets/v2/icon_menu_statement.png'),
          iconW: 19,
          iconH: 20,
          routeTo: 'StatementUploadList',
          index: 1,
          height: 110
        }
      ]
    },
    {
      title: 'Reports',
      display: true,
      index: 4,
      width: 81,
      subList: [
        {
          title: 'Policy Reports',
          icon: require('@/assets/v2/icon_menu_policy_report.png'),
          iconW: 20,
          iconH: 20,
          routeTo: 'PolicyReports',
          index: 0,
          height: 110
        },
        {
          title: 'Customize Reports',
          icon: require('@/assets/v2/icon_menu_policy_report.png'),
          iconW: 20,
          iconH: 20,
          routeTo: 'ReportsRules',
          index: 0,
          height: 110
        },
        {
          title: 'Case Reports',
          icon: require('@/assets/v2/icon_menu_case.png'),
          iconW: 20,
          iconH: 20,
          routeTo: 'CaseReports',
          index: 1,
          height: 110
        },
        {
          title: 'Statistic Analysis',
          icon: require('@/assets/v2/icon_menu_statistics.png'),
          iconW: 20,
          iconH: 20,
          routeTo: 'StatisticAnalysis',
          index: 2,
          height: 110
        }
      ]
    },
    // todo: hidden life insure cases
    // {
    //   title: 'Life Insure Cases',
    //   icon: require('@/assets/icon_menu_case.png'),
    //   iconOn: require('@/assets/icon_menu_case_on.png'),
    //   routeTo: 'LifeInsureCaseList',
    //   display: true,
    //   index: 5,
    //   width: 112
    // },
    {
      title: 'Tickets',
      routeTo: 'TicketDashborad',
      display: true,
      index: 5,
      width: 76,
      subList: [
        {
          title: 'Tickets',
          icon: require('@/assets/v2/icon_menu_ticket.png'),
          iconW: 20,
          iconH: 20,
          routeTo: 'TicketDashborad',
          index: 0,
          height: 90
        }
      ]
    },
    {
      title: 'Task',
      routeTo: 'TaskList',
      display: true,
      index: 6,
      width: 61,
      subList: [
        {
          title: 'Task',
          icon: require('@/assets/v2/icon_menu_task.png'),
          iconW: 19,
          iconH: 20,
          routeTo: 'TaskList',
          index: 0,
          height: 90
        }
      ]
    },
    {
      title: 'Phone Log',
      routeTo: 'PhoneLogs',
      display: true,
      index: 7,
      width: 96,
      subList: [
        {
          title: 'Phone Log',
          icon: require('@/assets/v2/icon_menu_phone_log.png'),
          iconW: 20,
          iconH: 20,
          routeTo: 'PhoneLogs',
          index: 0,
          height: 90
        }
      ]
    },
    {
      title: 'Messages',
      routeTo: 'Message',
      display: true,
      index: 8,
      width: 91,
      subList: [
        {
          title: 'Message',
          icon: require('@/assets/v2/icon_menu_message.png'),
          iconW: 20,
          iconH: 20.5,
          routeTo: 'Message',
          index: 0,
          height: 90
        }
      ]
    },
    {
      title: 'Settings',
      display: true,
      index: 9,
      width: 81,
      subList: [
        {
          title: 'General Agents',
          icon: require('@/assets/v2/icon_menu_general_agent.png'),
          iconW: 17.5,
          iconH: 20,
          routeTo: 'GeneralAgentsList',
          roleLimits: ['MANAGER'],
          index: 0,
          height: 110
        },
        {
          title: 'Carriers',
          icon: require('@/assets/v2/icon_menu_carrier.png'),
          iconW: 20.5,
          iconH: 19.5,
          routeTo: 'CarrierList',
          roleLimits: ['MANAGER'],
          index: 1,
          height: 90
        },
        {
          title: 'Insurance Products',
          icon: require('@/assets/v2/icon_menu_carrier_product.png'),
          iconW: 20,
          iconH: 20,
          routeTo: 'CarrierProductList',
          roleLimits: ['MANAGER'],
          index: 2,
          height: 110
        },
        {
          title: 'Third Parties',
          icon: require('@/assets/v2/icon_menu_third_party.png'),
          iconW: 21,
          iconH: 18,
          routeTo: 'ThirdPartyList',
          roleLimits: ['MANAGER'],
          index: 3,
          height: 110
        },
        {
          title: 'Source',
          icon: require('@/assets/v2/icon_menu_source.png'),
          iconW: 20,
          iconH: 20,
          routeTo: 'ProducerList',
          roleLimits: ['MANAGER'],
          index: 4,
          height: 90
        },
        {
          title: 'Agencies',
          icon: require('@/assets/v2/icon_menu_agency.png'),
          iconW: 20,
          iconH: 20,
          routeTo: 'AgenciesList',
          roleLimits: ['MANAGER'],
          index: 5,
          height: 90
        },
        {
          title: 'Books',
          icon: require('@/assets/v2/icon_menu_book.png'),
          iconW: 20.5,
          iconH: 20,
          routeTo: 'BooksList',
          roleLimits: ['MANAGER'],
          index: 6,
          height: 90
        },
        {
          title: 'Users',
          icon: require('@/assets/v2/icon_menu_user.png'),
          iconW: 20,
          iconH: 20,
          routeTo: 'UserList',
          roleLimits: ['MANAGER'],
          index: 7,
          height: 90
        },
        {
          title: 'Label',
          icon: require('@/assets/v2/icon_menu_label.png'),
          iconW: 20,
          iconH: 20,
          routeTo: 'LabelList',
          roleLimits: ['MANAGER'],
          index: 8,
          height: 90
        },
        {
          title: 'Change Password',
          icon: require('@/assets/v2/icon_menu_key.png'),
          iconW: 20,
          iconH: 20,
          routeTo: 'ChangePassword',
          index: 9,
          height: 110
        }
      ]
    }
  ]
  return list
}
